import fairHousingIcon from "./fairHousingIcon.svg";
import landleaseBuildingIcon from "./landleaseBuildingIcon.svg";
import postSubmitImage from "./postSubmitImage.svg";

export { fairHousingIcon, landleaseBuildingIcon, postSubmitImage };
